import React from 'react';
import { Box } from '@mui/material';

const GeometricBackground = ({ colors, renderWidth = 210 }) => {
  // Extract colors from design, with fallbacks
  const primaryColor = colors?.primary || '#e0e0e0';
  const secondaryColor = colors?.secondary || '#d0d0d0';
  const tertiaryColor = colors?.tertiary || '#c0c0c0';
  const quaternaryColor = colors?.quaternary || '#f0f0f0';
  
  const height = 297; // A4 height in mm

  // If no colors provided, don't render
  if (!colors) {
    console.warn('GeometricBackground: No colors received. Rendering nothing.');
    return null;
  }

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 0,
        overflow: 'hidden',
        pointerEvents: 'none',
      }}
    >
      <svg 
        width="100%" 
        height="100%" 
        viewBox={`0 0 ${renderWidth} ${height}`}
        preserveAspectRatio="xMidYMid slice"
        style={{ display: 'block' }}
      >
        {/* Large triangular shape at top-left */}
        <polygon
          points={`0,0 ${renderWidth * 0.4},0 0,${height * 0.3}`}
          fill={primaryColor}
          opacity="0.15"
        />
        
        {/* Large triangular shape at top-right */}
        <polygon
          points={`${renderWidth * 0.6},0 ${renderWidth},0 ${renderWidth},${height * 0.25}`}
          fill={secondaryColor}
          opacity="0.2"
        />
        
        {/* Medium triangular shape overlapping */}
        <polygon
          points={`${renderWidth * 0.3},0 ${renderWidth * 0.7},0 ${renderWidth * 0.5},${height * 0.15}`}
          fill={tertiaryColor}
          opacity="0.12"
        />
        
        {/* Additional geometric shape - rhombus/diamond */}
        <polygon
          points={`${renderWidth * 0.8},${height * 0.05} ${renderWidth * 0.95},${height * 0.15} ${renderWidth * 0.8},${height * 0.25} ${renderWidth * 0.65},${height * 0.15}`}
          fill={quaternaryColor}
          opacity="0.18"
        />
        
        {/* Large angular shape from left */}
        <polygon
          points={`0,${height * 0.1} ${renderWidth * 0.25},${height * 0.05} ${renderWidth * 0.35},${height * 0.2} 0,${height * 0.35}`}
          fill={primaryColor}
          opacity="0.1"
        />
        
        {/* Angled shape from right */}
        <polygon
          points={`${renderWidth * 0.75},0 ${renderWidth},${height * 0.08} ${renderWidth},${height * 0.4} ${renderWidth * 0.6},${height * 0.12}`}
          fill={secondaryColor}
          opacity="0.14"
        />
        
        {/* Small accent triangle */}
        <polygon
          points={`${renderWidth * 0.45},${height * 0.02} ${renderWidth * 0.55},${height * 0.02} ${renderWidth * 0.5},${height * 0.08}`}
          fill={tertiaryColor}
          opacity="0.25"
        />
        
        {/* Additional overlay shape for depth */}
        <polygon
          points={`${renderWidth * 0.15},0 ${renderWidth * 0.45},0 ${renderWidth * 0.25},${height * 0.18}`}
          fill={quaternaryColor}
          opacity="0.08"
        />
      </svg>
    </Box>
  );
};

export default GeometricBackground; 